module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero6.png?92d883da";